export default {
    merchantWebApiUrl: process.env.VUE_APP_MERCHANT_WEBAPI_URL as string,
    marketWebApiUrl: process.env.VUE_APP_MARKET_WEBAPI_URL as string,
    marketSiteUrl: process.env.VUE_APP_MARKET_SITE_URL as string,
	tenderWebApiUrl: process.env.VUE_APP_TENDER_WEBAPI_URL as string,
	baseTenderWebApiUrl: process.env.VUE_APP_TTENDER_WEBAPI as string,
    tenderMvcSiteUrl: process.env.VUE_APP_TENDER_MVC_SITE_URL as string,
    stockMvcSiteUrl: process.env.VUE_APP_STOCK_MVC_SITE_URL as string,
    stockSiteUrl: process.env.VUE_APP_STOCK_SITE_URL as string,
    dadataToken: process.env.VUE_APP_DADATA_TOKEN as string,
    onboardingWebApiUrl: process.env.VUE_APP_ONBOARDING_WEBAPI_URL as string,
    commonWebApiUrl: process.env.VUE_APP_COMMON_WEBAPI_URL as string,
    suppliersUrl: process.env.VUE_APP_SUPPLIERS_URL as string,
    suppliersSearchUrl: process.env.VUE_APP_SUPPLIERS_SEARCH_URL as string,
    supplierPageUrl: process.env.VUE_APP_SUPPLIER_URL as string,
    tradeUrl: process.env.VUE_APP_TRADE_URL as string,
    ssoSiteUrl: process.env.VUE_APP_SSO_SITE_URL as string,
    merchantInterfacesUrl: process.env.VUE_APP_MERCHANT_INTERFACES_URL as string,
    agreementDocsUrl: process.env.VUE_APP_AGREEMENT_DOCS_URL as string,
    platformName: process.env.VUE_APP_PLATFORM_NAME as string,
    showGuaranteeAgreement: process.env.VUE_APP_SHOW_GUARANTEE_AGREEMENT === 'true',
    placeHolderImageUrl: process.env.VUE_APP_PLACEHOLDER_IMAGE_URL as string,
    otcSiteUrl: process.env.VUE_APP_OTC_SITE_URL as string,
    hideSaleOut: process.env.VUE_APP_HIDE_SALE_OUT_CHECKBOX === 'true',
    maxBasicSpecsCount: parseInt(process.env.VUE_APP_MAX_BASIC_SPECS_COUNT as string),
    enableActualization: process.env.VUE_APP_ENABLE_ACTUALIZATION ==='true',
    enableDealProtect: process.env.VUE_APP_ENABLE_DEALPROTECT ==='true',
    isDealPortectDefault: process.env.VUE_APP_IS_DEALPROTECT_DEFAULT ==='true',
    signalRUrl: process.env.VUE_APP_SIGNAL_R_URL as string,
    showSpeedometer: process.env.VUE_APP_SHOW_SPEEDOMETER === 'true',
    manualLoadXlsxUrl: 'https://help.otc.ru/post/50360',
    manualLoadYmlUrl: 'https://help.otc.ru/post/6337120',
    maxFileSizeForUploading: 10485760, // размер файла в байтах
    needResponsibleUser: process.env.VUE_APP_NEED_RESPONSIBLE_USER ==='true',
}